export default {
  title: 'Cross-Border Assessment',
  noLongerRequired:
    'Pre-approval is no longer required for cross-border assessments.',
  noLongerRequiredDescription:
    'The assessment is now reviewed by Vamoz and released by HR. No action is needed from you, and you can close this window.'
};
